export default "https://d1e6s5z4lzmgxx.cloudfront.net/1e48d3d4-9cd4-48c4-b169-1af184d58c4c/images/piano-icon.svg?e906b53e9b6537dc04156bf3f7a977c7";